import { Injectable, ViewContainerRef } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { PrismDialogService } from '@shure/prism-angular-components';

import { CookieDialogComponent } from './cookie-dialog/cookie-dialog.component';
export interface DialogLocalStorage {
	doNotShowAgain: string[];
}

export const EMPTY_IGNORED_DIALOGS = { doNotShowAgain: [] };

@Injectable({ providedIn: 'root' })
export class CommonDialogsService {
	public ignoredDialogs$ = new ReplaySubject<DialogLocalStorage>(1);
	private readonly IGNOREDIALOGS_LOCAL_STORAGE_KEY = 'ignore_confirmation_dialogs';

	constructor(private readonly dialogService: PrismDialogService) {
		this.ignoredDialogs$.next(this.readIgnoredDialogs());
	}

	public clearIgnoredDialogs(): void {
		this.writeIgnoredDialogs(EMPTY_IGNORED_DIALOGS);
		this.ignoredDialogs$.next(EMPTY_IGNORED_DIALOGS);
	}

	public setIgnoredDialog(doNotShowDialog: boolean, id?: string): void {
		if (id) {
			const ignoredDialogs = this.readIgnoredDialogs();
			if (doNotShowDialog && !ignoredDialogs.doNotShowAgain.includes(id)) {
				ignoredDialogs.doNotShowAgain.push(id);
			}
			this.writeIgnoredDialogs(ignoredDialogs);
		}
	}

	public isDialogIgnored(id: string): boolean {
		const ignoredDialogs = this.readIgnoredDialogs();
		return ignoredDialogs.doNotShowAgain.indexOf(id) > -1;
	}
	/**
	 * Open a cookie dialog
	 */
	public openCookieDialog(viewContainer: ViewContainerRef): void {
		this.dialogService.openDialog<CookieDialogComponent, void, unknown>(CookieDialogComponent, viewContainer);
	}

	private readIgnoredDialogs(): DialogLocalStorage {
		const ignoredDialogs = navigator.cookieEnabled
			? localStorage.getItem(this.IGNOREDIALOGS_LOCAL_STORAGE_KEY)
			: '';
		if (!ignoredDialogs) {
			return EMPTY_IGNORED_DIALOGS;
		}
		return JSON.parse(ignoredDialogs);
	}

	private writeIgnoredDialogs(ignoredDialogs: DialogLocalStorage): void {
		localStorage.setItem(this.IGNOREDIALOGS_LOCAL_STORAGE_KEY, JSON.stringify(ignoredDialogs));
		this.ignoredDialogs$.next(ignoredDialogs);
	}
}
